<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>CONTENT.TITLE</div>

  <ion-segment class="cat-area" mode="md" [(ngModel)]="catSelect">
    <ion-segment-button value="all">
      <ion-label translate>CONTENT.ALL</ion-label>
    </ion-segment-button>
    <ion-segment-button value="active">
      <ion-label translate>CONTENT.ACTIVE</ion-label>
    </ion-segment-button>
  </ion-segment>

  <ion-searchbar show-clear-button="focus" [debounce]="500" (ionInput)="handleFilterInput($event)" [placeholder]="'CONTENT.PLACEHOLDER' | translate"></ion-searchbar>
</ion-header>

<ion-content class="page" no-bounce scroll>
  <div [ngClass]="'warn-en warn-en' + warnEn" translate>CONTENT.WARN_EN</div>
  <div class="buffer"></div>
  <ng-template [ngIf]="isLoading">
    <div class="v-box full-width full-height justify-around align-center">
      <ion-spinner color="dark"></ion-spinner>
    </div>
  </ng-template>
  <ng-template [ngIf]="!isLoading && !hasContents">
    <ion-label class="no-entries-label" *ngIf="!hasContentsUnfiltered" translate>CONTENT.NO_ENTRIES</ion-label>
    <ion-label class="no-entries-label" *ngIf="hasContentsUnfiltered" translate>CONTENT.NO_ENTRIES_FILTERED</ion-label>
  </ng-template>

  <flipcard [flipped]="catSelect == 'active'">
    <ng-template [ngIf]="hasContents" id="card1">
      <ion-list [ngClass]="hasContents ? 'cat-list show' : 'cat-list'">
        <div *ngFor="let keyword of keywords; trackBy: trackKeywords">
          <ion-item size="12" size-sm="12" (click)="selectKeyword(keyword)" [ngClass]="keyword == selectedKeyword ? 'cat-title selected' : 'cat-title'">
            <ion-label class="ion-text-wrap cat-title">
              <mark-query id="collHead" [text]="keyword" [query]="filterText"></mark-query>
            </ion-label>
            <ion-badge *ngIf="hasNew(keyword)" translate class="keyword-badge badge" slot="end">CONTENT.NEW</ion-badge>
            <ion-icon aria-hidden="true" name="close-outline" slot="end"></ion-icon>
          </ion-item>
          <div class="cat-body">
            <collapsible [expanded]="keyword == selectedKeyword">
              <ng-template ngFor let-userContent [ngForOf]="userContentsForKeyword[keyword]" let-last="last" [ngForTrackBy]="trackUserContent">
              <ion-item size="12" size-sm="12" (click)="userContentExpanded[userContent._id] = !userContentExpanded[userContent._id]" 
                [ngClass]="'item-level-2 content-title' + (last ? ' last' : '')" id="{{userContent._id + '_title'}}" >
                <ion-label class="ion-text-wrap">
                  <mark-query id="collHead" [text]="getLocalizedContentText(userContent.contentFull.title)" [query]="filterText"></mark-query>
                </ion-label>
                <ion-icon name="chevron-down-outline" slot="end" [ngClass]="userContentExpanded[userContent._id] !== undefined && userContentExpanded[userContent._id] === true ? 'chevron expanded' : 'chevron'"></ion-icon>
                <div class="badge-area">
                  <ion-badge *ngIf="!isLeader && showLeaderContent && userContent.contentFull.leadersOnly " class="badge badge-leader"><ion-icon name="people" class="icon"></ion-icon></ion-badge>
                  <ion-badge *ngIf="isNew(userContent)" translate class="badge">CONTENT.NEW</ion-badge>
                  <!--ion-badge *ngIf="userContent.state == 5" class="badge badge5"><ion-icon name="play" class="icon"></ion-icon></ion-badge-->
                  <!--ion-badge *ngIf="userContent.state == 6" class="badge badge6"><ion-icon name="pause" class="icon"></ion-icon></ion-badge-->
                  <ion-badge *ngIf="userContent.state == 9" class="badge badge9"><ion-icon name="checkmark" class="icon"></ion-icon></ion-badge>
                </div>
                <div class="suggest-area" *ngIf="userContent.suggest != undefined && (userContent.suggest > 0 || isShowSuggestRaw)">
                  <ion-badge *ngIf="userContent.suggest > 0" class="badge" translate>
                    CONTENT.SUGGESTED
                    <span *ngIf="isShowSuggestRaw">({{userContent.suggest}})</span>
                  </ion-badge>
                </div>
              </ion-item>
              <collapsible [expanded]="userContentExpanded[userContent._id] !== undefined && userContentExpanded[userContent._id] === true">

                <ion-item id='{{userContent._id}}' class="content-body item-level-3" (click)="showContent(userContent)">
                  <ion-grid>
                    <ion-row>
                      <ion-col size="12">
                        <rich-text class="description" [text]="getLocalizedContentText(userContent.contentFull.description)" [query]="filterText">
                        </rich-text>
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="userContent.state == 0">
                      <ion-col size="6">
                        <ion-label class="info ion-text-wrap" translate [translateParams]="{weeks: userContent.contentFull.weeks}">
                          {{userContent.contentFull.weeks > 1 ? 'CONTENT.DURATION_WEEKS' : 'CONTENT.DURATION_WEEK'}}
                        </ion-label>
                      </ion-col>
                      <ion-col size="6" class="button-field">
                        <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width" translate (click)="start(userContent, $event)">
                          CONTENT.BUTTON.START
                        </ion-button>
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="userContent.state == 3 && getPrice(userContent, products) != '-'">
                      <ion-col size="6">
                        <ion-label class="info ion-text-wrap" translate [translateParams]="{weeks: userContent.contentFull.weeks}">
                          {{userContent.contentFull.weeks > 1 ? 'CONTENT.DURATION_WEEKS' : 'CONTENT.DURATION_WEEK'}}
                        </ion-label>
                      </ion-col>
                      <ion-col size="6" class="button-field">
                        <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width ion-text-wrap" translate [translateParams]="{price: getPrice(userContent, products)}" (click)="purchase(userContent, $event)">
                          CONTENT.BUTTON.PURCHASE
                        </ion-button>
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="userContent.state == 5">
                      <ion-col size="12" *ngIf="!userContent.contentFull.pausable">
                        <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(userContent.startDate)}">
                          CONTENT.INFO.STARTED
                        </ion-label>
                      </ion-col>
                      <ion-col size="6" *ngIf="userContent.contentFull.pausable">
                        <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(userContent.startDate)}">
                          CONTENT.INFO.STARTED
                        </ion-label>
                      </ion-col>
                      <ion-col size="6" class="button-field" *ngIf="userContent.contentFull.pausable">
                        <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width" translate (click)="pause(userContent, $event)">
                          CONTENT.BUTTON.PAUSE
                        </ion-button>
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="userContent.state == 6">
                      <ion-col size="6">
                        <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(userContent.startDate)}">
                          CONTENT.INFO.PAUSED
                        </ion-label>
                      </ion-col>
                      <ion-col size="6" class="button-field">
                        <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width" translate (click)="resume(userContent, $event)">
                          CONTENT.BUTTON.RESUME
                        </ion-button>
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="userContent.state == 8">
                      <ion-col size="12">
                        <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(userContent.startDate), endDatum: formateDate(userContent.doneDate)}">
                          CONTENT.INFO.STARTED
                        </ion-label>
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="userContent.state == 8">
                      <ion-col size="6">
                        <ion-button fill="solid" shape="round" expand="block" color="light" text-wrap class="full-width ion-text-wrap" translate (click)="getPdf(userContent, $event)">
                          CONTENT.BUTTON.PDF
                        </ion-button>
                      </ion-col>
                      <ion-col size="6" class="button-field">
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="userContent.state == 9">
                      <ion-col size="12">
                        <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(userContent.startDate), endDatum: formateDate(userContent.doneDate)}">
                          CONTENT.INFO.DONE
                        </ion-label>
                      </ion-col>
                    </ion-row>
                    <ion-row class="action" *ngIf="userContent.state == 9">
                      <ion-col size="6">
                        <ion-button fill="solid" shape="round" expand="block" color="light" text-wrap class="full-width ion-text-wrap" translate (click)="getPdf(userContent, $event)">
                          CONTENT.BUTTON.PDF
                        </ion-button>
                      </ion-col>
                      <ion-col size="6" class="button-field">
                        <ion-button fill="solid" shape="round" expand="block" color="light" text-wrap class="full-width ion-text-wrap" translate (click)="restart(userContent, $event)">
                          CONTENT.BUTTON.RESTART
                        </ion-button>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-item>
          
              </collapsible>  
            </ng-template>
            </collapsible>
          </div>
        </div>
      </ion-list>
      <div *ngIf="leadaAboState == 2" class="abo">
        <ion-grid>
          <ion-row>
            <ion-col size="12">
              <div class="store-head" translate>CONTENT.ABO.TITLE
              </div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12">
              <div class="store-title">{{abo.title}}
              </div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12">
              <div class="store-description">{{abo.description}}
              </div>
            </ion-col>
          </ion-row>
          <ion-row class="action">
            <ion-col size="12" class="button-field">
              <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width" translate [translateParams]="{price: getProductPrice(abo)}" (click)="purchaseAbo()">
                CONTENT.ABO.BUTTON.PURCHASENOW
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ng-template>

    <ng-template [ngIf]="hasContents" id="card2">
      <ion-label class="no-entries-label" translate *ngIf="(userContentsActive === undefined || userContentsActive.length === 0) && !hasContentsActiveUnfiltered">CONTENT.NO_ENTRIES</ion-label>
      <ion-label class="no-entries-label" translate *ngIf="(userContentsActive === undefined || userContentsActive.length === 0) && hasContentsActiveUnfiltered">CONTENT.NO_ENTRIES_FILTERED</ion-label>
      <ion-list class="content-list active">
        <ng-template ngFor let-userContent [ngForOf]="userContentsActive" [ngForTrackBy]="trackUserContent">
          <ion-item size="12" size-sm="12" id='{{userContent._id}}' class="item-level-2"  (click)="showContent(userContent)">
            <ion-label class="ion-text-wrap content-title">
              <mark-query id="collHead" [text]="getLocalizedContentText(userContent.contentFull.title)" [query]="filterText"></mark-query>
            </ion-label>
            <div class="badge-area">
              <ion-badge *ngIf="!isLeader && showLeaderContent && userContent.contentFull.leadersOnly " class="badge badge-leader"><ion-icon name="people" class="icon"></ion-icon></ion-badge>
              <ion-badge *ngIf="isNew(userContent)" translate class="badge">CONTENT.NEW</ion-badge>
              <!--ion-badge *ngIf="userContent.state == 5" class="badge badge5"><ion-icon name="play" class="icon"></ion-icon></ion-badge-->
              <!--ion-badge *ngIf="userContent.state == 6" class="badge badge6"><ion-icon name="pause" class="icon"></ion-icon></ion-badge-->
              <ion-badge *ngIf="userContent.state == 9" class="badge badge9"><ion-icon name="checkmark" class="icon"></ion-icon></ion-badge>
            </div>
            <div class="suggest-area" *ngIf="userContent.suggest != undefined && (userContent.suggest > 0 || isShowSuggestRaw)">
              <ion-badge *ngIf="userContent.suggest > 0" class="badge" translate>
                CONTENT.SUGGESTED
                <span *ngIf="isShowSuggestRaw">({{userContent.suggest}})</span>
              </ion-badge>
            </div>
          </ion-item>
          <ion-item size="12" size-sm="12" [ngClass]="getContentClass(userContent)" (click)="showContent(userContent)">
            <ion-grid>
              <ion-row>
                <ion-col size="12">
                  <rich-text class="description" [text]="getLocalizedContentText(userContent.contentFull.description)" [query]="filterText">
                  </rich-text>
                </ion-col>
              </ion-row>
              <ion-row class="action" *ngIf="userContent.state == 0">
                <ion-col size="6">
                  <ion-label class="info ion-text-wrap" translate [translateParams]="{weeks: userContent.contentFull.weeks}">
                    {{userContent.contentFull.weeks > 1 ? 'CONTENT.DURATION_WEEKS' : 'CONTENT.DURATION_WEEK'}}
                  </ion-label>
                </ion-col>
                <ion-col size="6" class="button-field">
                  <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width" translate (click)="start(userContent, $event)">
                    CONTENT.BUTTON.START
                  </ion-button>
                </ion-col>
              </ion-row>
              <ion-row class="action" *ngIf="userContent.state == 3 && getPrice(userContent, products) != '-'">
                <ion-col size="6">
                  <ion-label class="info ion-text-wrap" translate [translateParams]="{weeks: userContent.contentFull.weeks}">
                    {{userContent.contentFull.weeks > 1 ? 'CONTENT.DURATION_WEEKS' : 'CONTENT.DURATION_WEEK'}}
                  </ion-label>
                </ion-col>
                <ion-col size="6" class="button-field">
                  <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width ion-text-wrap" translate [translateParams]="{price: getPrice(userContent, products)}" (click)="purchase(userContent, $event)">
                    CONTENT.BUTTON.PURCHASE
                  </ion-button>
                </ion-col>
              </ion-row>
              <ion-row class="action" *ngIf="userContent.state == 5">
                <ion-col size="12" *ngIf="!userContent.contentFull.pausable">
                  <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(userContent.startDate)}">
                    CONTENT.INFO.STARTED
                  </ion-label>
                </ion-col>
                <ion-col size="6" *ngIf="userContent.contentFull.pausable">
                  <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(userContent.startDate)}">
                    CONTENT.INFO.STARTED
                  </ion-label>
                </ion-col>
                <ion-col size="6" class="button-field" *ngIf="userContent.contentFull.pausable">
                  <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width" translate (click)="pause(userContent, $event)">
                    CONTENT.BUTTON.PAUSE
                  </ion-button>
                </ion-col>
              </ion-row>
              <ion-row class="action" *ngIf="userContent.state == 6">
                <ion-col size="6">
                  <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(userContent.startDate)}">
                    CONTENT.INFO.PAUSED
                  </ion-label>
                </ion-col>
                <ion-col size="6" class="button-field">
                  <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width" translate (click)="resume(userContent, $event)">
                    CONTENT.BUTTON.RESUME
                  </ion-button>
                </ion-col>
              </ion-row>
              <ion-row class="action" *ngIf="userContent.state == 9">
                <ion-col size="12">
                  <ion-label class="info ion-text-wrap" translate [translateParams]="{startDatum: formateDate(userContent.startDate), endDatum: formateDate(userContent.doneDate)}">
                    CONTENT.INFO.DONE
                  </ion-label>
                </ion-col>
              </ion-row>
              <ion-row class="action" *ngIf="userContent.state == 9">
                <ion-col size="6">
                  <ion-button fill="solid" shape="round" expand="block" color="light" text-wrap class="full-width ion-text-wrap" translate (click)="getPdf(userContent, $event)">
                    CONTENT.BUTTON.PDF
                  </ion-button>
                </ion-col>
                <ion-col size="6" class="button-field">
                  <ion-button fill="solid" shape="round" expand="block" color="light" text-wrap class="full-width ion-text-wrap" translate (click)="restart(userContent, $event)">
                    CONTENT.BUTTON.RESTART
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-item>
        </ng-template>    
      </ion-list>

    </ng-template>

  </flipcard>
  <instruction key="contents">{{'INSTRUCTION.CONTENTS' | translate}}</instruction>

</ion-content>
